/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const studiosven: CommunityData = {
  code: "studiosven",
  inviteCode: "studiosven",
  name: "Studio Sven",
  thumbnail: "/assets/customizations/studioSven/thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/studiosven`,
  socials: {},
  styles: {
    global: {
      counterColor: "#FFFFFF",
      logo: {
        src: "/assets/customizations/studioSven/logo.png",
        styles: "w-[144px] mb-[-20px]",
      },
      alternativeLogo: {
        src: "/assets/customizations/studioSven/alt-logo.png",
        styles: "w-[115px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[2px] rounded-[8px] border-[#434343]",
      bgColor: "#000000",
      asideBg: "#141414",
      asideStyles: "border-r-[1px] border-r-[#434343]",
      contentBg: "#141414",
      bgDesktop: "/assets/customizations/studioSven/video-bg.mp4",
      bgMobile: "/assets/customizations/studioSven/video-bg.mp4",
      mainFont: "font-['FiraSans']",
      primaryButton:
        "flex mt-2 !text-[#000000] rounded-[4px] font-['FiraSansMedium'] font-medium justify-center items-center !text-[16px] leading-[18px] !h-[43px] bg-[#FFFFFF] !px-[16px] sm:!min-w-[154px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "border-r-[1px] border-[#000000]",
      iconsColor: "#FFFFFF",
      separator: "border-t-[#434343] border-t border-opacity-50",
      item: "text-[16px] h-[40px] text-[#FFFFFF] flex sm:justify-start justify-center items-center sm:!pt-2 !pt-6",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[31px] leading-[40px] font-['PlayfairDisplay'] text-[#FFFFFF] uppercase",
      announcements: {
        lg: {
          subtitle:
            "!text-[12px] font-['Barlow'] font-semibold px-[6px] !bg-[#141414] -ml-1 mb-[2px] !text-[#FFFFF] w-fit h-[26px] border-[2px] border-[#434343] flex items-center rounded-[6px]",
          title:
            "leading-[16px] font-['FiraSansMedium'] font-medium !text-[#FFFFFF] !text-[12px] -mb-2 mt-[-4px] w-fit flex items-cente pt-1",
        },
        sm: {
          subtitle:
            "!text-[12px] font-['Barlow'] font-semibold px-[6px] !bg-[#141414] -ml-1 mb-[2px] !text-[#FFFFF] w-fit h-[26px] border-[2px] border-[#434343] flex items-center rounded-[6px]",
          title:
            "leading-[16px] font-['FiraSansMedium'] font-medium !text-[#FFFFFF] !text-[12px] mt-[-4px] w-fit flex items-cente pt-1",
        },
      },
      event: {
        title: "font-['FiraSansMedium'] font-medium text-[15px] text-[#FFFFFF] one-line-truncate",
        subtitle: "text-[14px] text-[#FFFFFF] leading-[16px]",
      },
      shop: {
        title: "text-[14px] leading-[16px] text-[#FFFFFF] font-['FiraSansMedium'] font-medium",
        text: "text-[14px] leading-[16px] text-[#FFFFFF]",
        customShopImage: "/assets/customizations/studioSven/img_shop.png",
      },
      emptyOrLoadingState: "text-[16px] !text-[#FFFFFF]",
    },
    events: {
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[31px] leading-[40px] font-['PlayfairDisplay'] text-[#FFFFFF] uppercase",
      sectionHeader:
        "text-[20px] text-[#FFFFFF] one-line-truncate font-['FiraSansMedium'] font-medium",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#434343]",
      title:
        "text-[24px] leading-[26px] text-[#FFFFFF] font-['FiraSansMedium'] font-medium one-line-truncate my-2",
      duration: "text-[14px] text-[#FFFFFF]",
      address: "text-[14px] text-[#FFFFFF]",
      emptyOrLoadingState: "!text-[#FFFFFF] text-[16px]",
    },
    event: {
      container: "flex flex-col sm:p-11 p-6",
      blockContainer: "flex flex-col gap-3",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#434343]",
      header:
        "text-[31px] leading-[40px] font-['PlayfairDisplay'] text-[#FFFFFF] uppercase !mt-0 sm:mb-0 mb-[24px]",
      sectionSubtitle: "text-[14px] text-[#FFFFFF]",
      sectionTitle:
        "text-[20px] text-[#FFFFFF] one-line-truncate font-['FiraSansMedium'] font-medium",
      text: "text-[14px] text-[#FFFFFF]",
      map: {
        border: "mb-2 flex justify-center overflow-hidden",
        pin: "",
        pinColor: "#000000",
        strokeColor: "#000000",
      },
      emptyOrLoadingState: "text-[16px] text-[#FFFFFF]",
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "!mt-0 text-[31px] leading-[40px] font-['PlayfairDisplay'] text-[#FFFFFF] uppercase",
        subtitle: "text-[14px] text-[#FFFFFF]",
      },
      separator: "sm:my-8 my-6 border-b-[#434343] border-b-[1px]",
      ticket: {
        title: "text-[20px] text-[#FFFFFF] font-['FiraSansMedium'] font-medium",
        description: "capitalize !text-[12px] text-[#FFFFFF]",
        text: "capitalize !text-[12px] text-[#FFFFFF]",
        price: "text-[20px] text-[#FFFFFF] font-['FiraSansMedium'] font-medium",
        counterContainer: "text-[12px] border-[1px] rounded-[4px] !border-[#FFFFFF]",
        quantity: "text-nowrap text-[12px] text-[#FFFFFF]",
      },
    },
    announcements: {
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[31px] leading-[40px] font-['PlayfairDisplay'] text-[#FFFFFF] uppercase",
      created: "text-[14px] leading-[16px] text-[#FFFFFF]",
      title: "text-[24px] leading-[26px] text-[#FFFFFF] font-['FiraSansMedium'] font-medium",
      description: "text-[14px] leading-[16px] text-[#FFFFFF]",
      emptyOrLoadingState: "text-[16px] text-[#FFFFFF]",
    },
    announcement: {
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      created: "text-[14px] leading-[16px] text-[#FFFFFF]",
      title: "text-[24px] leading-[26px] text-[#FFFFFF] font-['FiraSansMedium'] font-medium",
      description: "text-[14px] leading-[16px] text-[#FFFFFF]",
      likeIconColor: "#FFFFFF",
      likeCount: "text-[#FFFFFF]",
      commentIconColor: "#FFFFFF",
      commentCount: "text-[#FFFFFF]",
      emptyOrLoadingState: "text-[16px] text-[#FFFFFF]",
    },
    shop: {
      container: "mb-16 sm:p-11 p-7 sm:pb-8",
      header: "text-[31px] leading-[40px] font-['PlayfairDisplay'] text-[#FFFFFF] uppercase",
      sectionTitle:
        "text-[20px] text-[#FFFFFF] one-line-truncate font-['FiraSansMedium'] font-medium",
      separator: "mt-2 sm:mb-7 mb-6 border-b border-b-[1px] border-[#434343]",
      emptyState: "text-[16px] text-[#FFFFFF]",
    },
    linktree: {
      container:
        "font-['FiraSans'] flex flex-col items-center h-full w-full bg-cover min-h-screen bg-[#000000] p-[64px]",
      bgDesktop: "/assets/customizations/studioSven/video-bg.mp4",
      bgMobile: "/assets/customizations/studioSven/video-bg.mp4",
      communityInfo: {
        logo: "h-[92px] w-[92px] mb-6",
        name: "text-[31px] font-['PlayfairDisplay'] text-[#FFFFFF]",
        location:
          "font-bold font-['RobotoCondensed'] text-[#FFFFFF] text-[16px] leading-[19.2px] text-center mb-2",
        description: "text-[#FFFFFF] text-[14px] leading-[17px] text-center mb-4",
        socialMediaIconColor: "#FFFFFF",
        button:
          "text-[16px] font-['FiraSansMedium'] font-medium flex mt-2 !text-[#000000] justify-center items-center !h-[43px] bg-[#FFFFFF] rounded-[4px] !px-[20px] text-nowrap cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[42px] text-[#FFFFFF] border-[1px] border-[#414141] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#141414] rounded-[4px] items-center text-[14px]",
        emptyState: {
          container:
            "border-[#414141] border-[1px] sm:w-[500px] w-[95vw] bg-[#141414] rounded-[4px] flex justify-between flex flex-col justify-center items-center p-[34px] mb-[32px]",
          title: "text-[16px] font-['FiraSansMedium'] font-medium !text-[#FFFFFF]",
          text: "text-[14px] !text-[#FFFFFF]",
          button:
            "text-[16px] font-['FiraSansMedium'] font-medium flex mt-7 !text-[#000000] justify-center items-center !h-[43px] bg-[#FFFFFF] rounded-[4px] !px-[20px] text-nowrap cursor-pointer",
        },
        header:
          "font-['FiraSansMedium'] font-medium text-[20px] leading-[24px] !text-[#FFFFFF] mb-[10px] text-center w-screen",
        container: "gap-4 flex flex-col items-center",
        event: {
          container:
            "overflow-hidden rounded-[7px] border-[#414141] border-[2px] bg-[#141414] sm:w-[500px] w-[95vw]",
          name: "font-medium font-['FiraSansMedium'] text-[20px] text-[#FFFFFF] leading-[24px] mb-1 sm:w-[390px] w-[65vw]",
          duration: "text-[14px] leading-[17px] uppercase text-[#FFFFFF]",
          location: "text-[14px] leading-[17px] text-[#FFFFFF]",
          startDate:
            "!w-[64px] h-[64px] text-[#FFFFFF] rounded-[4px] font-medium font-['FiraSansMedium'] text-[20px] h-[64px] bg-[#141414] border-[1px] border-[#414141] flex flex-col justify-center items-center gap-1",
          button:
            "flex !text-[#000000] justify-center font-medium font-['FiraSansMedium'] items-center !text-[16px] !h-[43px] rounded-[4px] mt-4 bg-[#FFFFFF] !px-[16px] text-nowrap cursor-pointer w-fit",
          product: {
            container:
              "h-[74px] border-t border-t-[#565656] px-4 items-center flex justify-between",
            name: "text-[16px] font-bold font-['RobotoCondensed'] text-[#FFFFFF] leading-[19.2px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[14px] leading-[17px] text-[#FFFFFF]",
            status: "text-[16px] leading-[20px] text-[#FFFFFF] font-bold font-['RobotoCondensed']",
            link: "text-[14px] leading-[17px] text-[#FFFFFF]",
            button:
              "flex !text-[#000000] justify-center font-medium font-['FiraSansMedium'] items-center !text-[16px] !h-[43px] rounded-[4px] bg-[#FFFFFF] !px-[16px] text-nowrap cursor-pointer w-fit",
          },
        },
        collapsedEvent: {
          container:
            "h-[64px] border-[#434343] rounded-[4px] border-[2px] bg-[#141414] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between pr-2",
          media: "overflow-hidden m-2 rounded-[4px]",
          name: "text-[16px] font-bold font-['RobotoCondensed'] text-[#FFFFFF] leading-[16px] pt-[2px] sm:w-[390px] w-[65vw] one-line-truncate",
          duration: "!text-[14px] mt-[-2px] uppercase text-[#FFFFFF]",
          plusIconColor: "#FFFFFF",
        },
        seeAllEvents:
          "text-[12px] text-[#FFFFFF] underline text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        container: "flex flex-col gap-4",
        loadingState:
          "mb-[42px] text-[#FFFFFF] border-[1px] border-[#414141] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#141414] rounded-[4px] items-center text-[14px]",
        header:
          "font-['FiraSansMedium'] font-medium text-[20px] leading-[24px] !text-[#FFFFFF] mb-[10px] text-center w-screen",
        oneNews: {
          container:
            "pr-2 overflow-hidden border-[#434343] rounded-[4px] border-[2px] bg-[#141414] h-[80px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between",
          media: "rounded-[4px] overflow-hidden w-[48px] h-[48px] ml-4 mr-2 mt-4",
          name: "text-[#FFFFFF] font-['RobotoCondensed'] font-bold mt-[2px] !text-[16px] leading-[19.2px] mb-1 one-line-truncate sm:w-[390px] w-[65vw]",
          created: "text-[14px] leading-[14px] mt-[-4px] text-[#FFFFFF] opacity-[80%]",
          triangleIconColor: "#FFFFFF",
        },
        seeAllNews:
          "text-[12px] text-[#FFFFFF] underline text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        container: "flex flex-col gap-[10px] mb-[40px]",
        loadingState:
          "mb-[42px] text-[#FFFFFF] border-[1px] border-[#414141] !h-[56px] sm:w-[500px] w-[95vw] p-6 flex bg-[#141414] rounded-[4px] items-center text-[14px]",
        header:
          "font-['FiraSansMedium'] font-medium text-[20px] leading-[24px] !text-[#FFFFFF] mb-[10px] text-center w-screen",
        link: {
          container:
            "h-[56px] border-[2px] rounded-[4px] border-[#414141] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#141414]",
          name: "ml-1 font-['RobotoCondensed'] font-bold text-[16px] text-[#FFFFFF] leading-[16px] mb-[6px] mt-[6px] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#FFFFFF",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "uppercase font-mono text-[11px] font-bold text-[#FFFFFF]",
      },
    },
  },
}

export default studiosven
